import { useMemo } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router'
import { AuthProvider, useAuth } from './auth/AuthContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import { I18nProvider } from './i18n'
import { routes } from './routes'

function Providers() {
  const { account } = useAuth()
  const router = useMemo(() => createBrowserRouter(routes), [])
  return (
    <I18nProvider userId={account?.id ?? null} accountLocale={account?.locale}>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </I18nProvider>
  )
}

export function App() {
  return (
    <AuthProvider>
      <Providers />
    </AuthProvider>
  )
}
